import {useEffect, useState} from 'react';
import type {
  parseReportSummary,
  reportSummary,
} from '../../../core/repositories/reportSummaryRepository';
import {parseSummaries} from './parseReportSummaryResponse';

type ReportSummaryData = reportSummary;

export const useParseSummaries = (
  reportSummaryData: ReportSummaryData | undefined,
) => {
  const [result, setResult] = useState<parseReportSummary[]>([]);
  const [reference, setReference] = useState<number[]>([]);
  const [companyName, setCompanyName] = useState<string>('');

  useEffect(() => {
    const summaries = reportSummaryData?.summaries;
    if (summaries) {
      const {result, mergedResult, reference} = parseSummaries(summaries);
      if (mergedResult) {
        setResult(mergedResult);
      } else {
        setResult(result);
      }

      setReference(reference);
    }

    setCompanyName(reportSummaryData?.companyName || '');
  }, [reportSummaryData]);

  return {result, companyName, reference};
};
